<template>
	<div class="artist" :class="{ 'artist--featured': isFeatured }">
		<PictureImg
			class="artist__image"
			:media="image"
			v-if="isFeatured"
		></PictureImg>
		<div>
			<div class="artist__tag" v-if="isFeatured">{{ tag }}</div>
		</div>
		<div>
			<div class="artist__title">
				<div class="artist__name">{{ name }}</div>
				<div class="artist__job" v-if="job">
					<span v-if="isFeatured">&nbsp;-&nbsp;</span>{{ job }}
				</div>
			</div>
			<div class="artist__country" v-if="country && !isFeatured">
				<CountryFlagIcon :country-code="countryCode" /> {{ country }}
			</div>
		</div>
		<div class="artist__content" v-html="content" v-if="isFeatured"></div>
		<div class="artist__socials">
			<a
				class="artist__social"
				v-if="facebookLink && facebookLink.href"
				:href="facebookLink.href"
				target="_blank"
			>
				<SvgIcon icon="facebook" color="white" />
				{{ facebookLink.text }}
			</a>
			<a
				class="artist__social"
				v-if="instagramLink && instagramLink.href"
				:href="instagramLink.href"
				target="_blank"
			>
				<SvgIcon icon="instagram" color="white" />
				{{ instagramLink.text }}
			</a>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	tag: { type: String, required: false, default: "" },
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const image = computed(() => props.fields?.image?.value);
const name = computed(() => props.fields?.name?.value);
const job = computed(() => props.fields?.job?.value);
const country = computed(() => props.fields?.country?.value);
const countryCode = computed(() => props.fields?.countryCode?.value);
const content = computed(() => props.fields?.content?.value);
const instagramLink = computed(() => props.fields?.instagram?.value);
const facebookLink = computed(() => props.fields?.facebook?.value);

const isFeatured = computed(() => !!props.tag);
</script>

<style lang="scss">
.artist {
	color: var(--color-white, #fff);
	padding: var(--spacing-2, 16px);
	display: flex;
	flex-direction: column;
	gap: var(--spacing-3, 24px);

	.artist__image img {
		padding: 0;
		border-radius: 16px;
		overflow: hidden;
	}

	&.artist--featured .artist__title {
		.artist__name,
		.artist__job {
			font-size: var(--text-xl, 24px);
			font-weight: 300;
			line-height: 120%;
			display: inline;
			color: var(--color-white, #fff);
		}
	}

	.artist__name {
		color: var(--color-white, #fff);
		font-size: var(--text-base, 16px);
		font-weight: 900;
		line-height: 140%;
		text-transform: uppercase;
	}

	.artist__country,
	.artist__job {
		color: var(--color-white, #fff);
		font-size: var(--text-xs, 12px);
		font-weight: 400;
		line-height: 140%;
	}

	.artist__tag {
		display: inline-block;
		text-transform: uppercase;
		border-radius: 80px;
		background: var(--Tertiary-Lilas, #d7a6fb);
		padding: var(--spacing-1, 8px) var(--spacing-105, 12px);
		color: var(--color-black, #000);
		font-size: 11px;
		font-weight: 400;
		line-height: 1;
	}

	.artist__content {
		color: var(--color-white, #fff);
		font-size: var(--text-sm, 14px);
		font-style: normal;
		font-weight: 300;
		line-height: 140%;
	}

	.artist__social {
		color: var(--color-white, #fff);
		font-size: var(--text-base, 16px);
		font-weight: 700;
		line-height: 140%; /* 22.4px */
		text-decoration-line: underline !important;
		display: flex;
		gap: var(--spacing-1, 8px);
		padding: var(--spacing-1, 8px) 0;
		border: none !important;
	}
}
</style>
